export default __webpack_public_path__ + "static/media/new_releases_FILL0_wght400_GRAD0_opsz24.767250b1.svg";